import { render, staticRenderFns } from "./modalSelecAvatar.vue?vue&type=template&id=2bee5ec6&"
import script from "./modalSelecAvatar.vue?vue&type=script&lang=js&"
export * from "./modalSelecAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports